import {
  Component,
  Renderer2,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
  SimpleChanges,
} from '@angular/core';
import { GeneralService } from 'src/app/_utlis/general/general.service';
import { environment } from 'src/environments/environment';
import { ToastService } from '../../services/toast/toast.service';

import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { TranslatePipe } from '@ngx-translate/core';
@Component({
    selector: 'app-terms-of-service',
        standalone: true,
templateUrl: './terms-of-service.component.html',
    styleUrls: ['./terms-of-service.component.scss'],
    imports: [MatProgressSpinner]
})
export class TermsOfServiceComponent {
  DefualtPath = environment.wordpressUrl;
  isLoading = false;
  data: any;
  constructor(
    private generalService: GeneralService,
    private toastService: ToastService,
    private renderer: Renderer2,
    private el: ElementRef,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.isLoading = true;
    this.generalService.TermsOfService().subscribe(
      (res) => {
        this.data = res.data.value;
        this.isLoading = false;
        // this.cdr.detectChanges(); // Trigger change detection
        // this.applyStyles();
      },
      (err) => {
        this.toastService.showError(err.error.message);
      }
    );
  }

  applyStyles() {
    const contentDiv = this.el.nativeElement.querySelector('.content');
    // console.log(contentDiv); // Log to check if contentDiv is found
    if (contentDiv) {
      const images = contentDiv.querySelectorAll('img.image_resized');
      images.forEach((img: HTMLImageElement) => {
        this.renderer.setStyle(img, 'width', '200px');
        this.renderer.setStyle(img, 'height', 'auto');
      });
    } else {
      console.error('Content div not found');
    }
  }
}
